import { BASE_TOOL_COMMON_PROPS } from '@/toolSelection/baseTool.constants';
import { BaseToolStore } from '@/toolSelection/baseTool.store';
import { TREND_TOOLS } from '@/toolSelection/investigate.constants';

interface ItemPropertiesState {
  advancedParametersCollapsed: boolean;
  duplicatingItemId: string;
}

export type ItemPropertiesDehydratedState = ItemPropertiesState;

export class ItemPropertiesStore extends BaseToolStore {
  type = TREND_TOOLS.PROPERTIES;
  static readonly storeName = 'sqItemPropertiesStore';

  initialize(): void {
    const initialState: ItemPropertiesState = {
      advancedParametersCollapsed:
        this.state?.get('advancedParametersCollapsed') ?? BASE_TOOL_COMMON_PROPS.advancedParametersCollapsed,
      duplicatingItemId: '',
    };
    this.state = this.immutable(initialState);
  }

  get duplicatingItemId(): string {
    return this.state.get('duplicatingItemId');
  }

  /**
   * Exports state so it can be used to re-create the state later using `rehydrate`.
   *
   * @return {Object} State for the store
   */
  dehydrate(): ItemPropertiesDehydratedState {
    return this.state.serialize();
  }

  /**
   * Sets the references panel state
   *
   * @param dehydratedState - Previous state usually obtained from `dehydrate` method.
   */
  rehydrate(dehydratedState: Partial<ItemPropertiesDehydratedState>): void {
    this.state.merge(dehydratedState);
  }

  protected readonly handlers = {
    ...this.baseHandlers,
    PROPERTIES_SET_DUPLICATING_ITEM_ID: ({ id }: { id: string }) => {
      this.state.set('duplicatingItemId', id);
    },
  };
}
